<template>
  <p class="truncate text-sm font-semibold">{{ notification.runArgs?.fileName }}</p>
  <p v-if="isInProgress" class="text-sm text-gray-600">
    <span class="text-warning-700 font-medium">Generating report...</span>
  </p>
  <p
    v-else-if="notification.status === NOTIFICATION_STATUS.SUCCESS"
    class="flex items-center gap-1.5 text-sm whitespace-nowrap text-gray-600"
  >
    Generated
    <template v-if="isActionable">
      <DocumentDownloadIcon
        class="h-4 w-4 shrink-0"
        :class="isDownloading ? 'text-gray-400' : 'text-blue-600'"
      />
      <span
        class="font-medium underline"
        :class="isDownloading ? 'text-gray-400' : 'text-blue-600'"
      >
        Click here to download
      </span>
    </template>
  </p>
  <p v-else-if="notification.status === NOTIFICATION_STATUS.ERROR" class="text-sm text-gray-600">
    Problem generating. Please try again.
  </p>
  <p
    v-if="notification.status === NOTIFICATION_STATUS.SUCCESS && !isActionable"
    class="text-xs text-gray-400"
  >
    Link Expired
  </p>
</template>

<script setup>
import { computed } from 'vue'
import DocumentDownloadIcon from '@/assets/untitled-ui/file-download-03.svg'
import { NOTIFICATION_STATUS, UI_BEHAVIOUR } from '@/lib/NotificationConstants'

const props = defineProps({
  notification: {
    type: Object,
    required: true
  },
  isDownloading: {
    type: Boolean,
    default: false
  }
})

const isInProgress = computed(() => props.notification.status === NOTIFICATION_STATUS.IN_PROGRESS)
const isActionable = computed(() =>
  props.notification.uiBehaviours?.includes(UI_BEHAVIOUR.ACTIONABLE)
)
</script>
